import { AfterViewInit, Directive, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { tap } from 'rxjs/operators';
import { ListingComponent } from 'src/app/_shared/components/listing/listing.component';
import { SubscriptionManager } from 'src/app/_core/tools/subscription-manager';

@Directive({
    selector: '[appListingQuickFilters]',
    exportAs: 'appListingQuickFilters',
    standalone: false
})
export class ListingQuickFiltersDirective extends SubscriptionManager implements AfterViewInit {

    @Input() formGroup: FormGroup;

    @Input() formatFiltersFunction: (filters: Record<string, any>) => Record<string, any>;

    constructor(private readonly listingComponent: ListingComponent<any>) {
        super();
    }

    search(): void {
        const values = {
            ...this.listingComponent.dataSource.filters.value,
            ...this.formGroup.value
        };

        if (this.listingComponent.filtersComponent) {
            this.listingComponent.filtersComponent.updateForm(values);
            this.listingComponent.applyFilters();
        } else {
            this.listingComponent.applyFilters(values);
        }
    }

    ngAfterViewInit(): void {
        this.watch$ = this.listingComponent.dataSource.filters.change$.pipe(
            tap(e => {
                let filters = this.formatFiltersFunction ? this.formatFiltersFunction(e) : e;

                if (this.listingComponent.filtersComponent) {
                    filters = this.listingComponent.filtersComponent.formatFilters(e);
                }

                this.formGroup.patchValue(filters, {emitEvent: false});
            })
        );
    }
}
